import { Component } from '@angular/core';

@Component({
    selector: 'signup-layout',
    templateUrl: './signup-layout.component.html',
    styleUrls: ['./signup-layout.component.scss']
})
export class SignupLayoutComponent {
    constructor() { }
}
